// Module
var code = "<div class=\"row page-title\">\r\n    <h1 ng-transclude></h1>\r\n    <div id=\"sub-title\" class=\"page-subtitle\" ng-if=\"subTitle.length > 0\">\r\n        <span>{{::subTitle}}</span>\r\n    </div>\r\n</div>";
// Exports
module.exports = code;